import React from "react"
import { Text } from "@chakra-ui/react"

type Props = {
  unsubscribed: boolean;
}

const EmailSubscriptionCell = ({ unsubscribed }: Props) => (
  <Text fontSize="sm" color={unsubscribed ? "red.500" : undefined} noOfLines={1}>
    {unsubscribed ? "Unsubscribed" : "Subscribed"}
  </Text>
)

export default EmailSubscriptionCell
